
import React from 'react'
import styled, { keyframes } from 'styled-components';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import * as actions from 'actions';
import { connect } from 'react-redux';

const notificationAnimation = keyframes`
    0% {
        right: -10px;
        opacity: 0;
    }
    20% {
        right: 50px;
        opacity: 0.8;
    }
    80%{
        right: 50px;
        opacity: 0.8;
    }
    100%{
        right: -10px;
        opacity: 0;
    }
`
const NotificationWrapper = styled.div`
    position: fixed;
    right: 50px;
    top: 100px;
    background: ${props => props.type === 'success' ? '#00a2be' : '#d13f3c'};
    padding: 20px;
    border-radius: 3px;
    opacity: 0.8;
    width: 200px;
    box-shadow: 3px 4px 10px 0px;
    display: ${ props => props.isVisible ? 'flex' : 'none'};
    align-items: center;
    animation: ${notificationAnimation} 8s ease-in;
    z-index: 1000;
`
const NotificationBodyWrapper = styled.div`
    margin-left: 10px;
`
const NotificationTitle = styled.h1`
    color: white;
    margin: 0;
    font: 14px Open Sans, Helvetica, sans-serif;
`
const NotificationMessage = styled.p`
    color: white;
    margin: 0;
    font: 12px Open Sans, Helvetica, sans-serif;
`

class CompanyNotification extends React.Component{
    render(){
        const { title, message, isVisible, type } = this.props;
        let logoType = 'times-circle'
        if( type === 'success') logoType = 'check-circle'
        return (
            <NotificationWrapper isVisible={isVisible} type={type}>
                <FontAwesomeIcon icon={logoType} color="white" size="3x"/>
                <NotificationBodyWrapper>
                    <NotificationTitle>
                        {title}
                    </NotificationTitle>
                    <NotificationMessage>
                        {message}
                    </NotificationMessage>
                </NotificationBodyWrapper>
            </NotificationWrapper>
        )
    }
}

const mapStateToProps = ({ companyNotification }) => ({
    title: companyNotification.title,
    message: companyNotification.message,
    isVisible: companyNotification.isVisible,
    type: companyNotification.type
});

export default connect(mapStateToProps, actions)(CompanyNotification);




// WEBPACK FOOTER //
// ./src/js/containers/CompanyContainer/CompanyNotification.jsx